import { p as prisma } from "../../../../chunks/prisma.js";
import auth from "../../../../chunks/auth.js";
import { fail, redirect } from "@sveltejs/kit";
import { m as maxAge, s as secure, r as refreshTokenMaxAge } from "../../../../chunks/utils2.js";
import { v as validateLogin } from "../../../../chunks/index4.js";
const actions = {
  default: async ({ request, cookies }) => {
    const formData = Object.fromEntries((await request.formData()).entries());
    const validation = validateLogin(formData);
    if (!validation.success) {
      return fail(400, {
        data: formData,
        errors: validation.errors
      });
    }
    const { email, password } = validation.data;
    let user;
    try {
      user = await prisma.user.findUnique({ where: { email } });
      if (!user) {
        return fail(400, {
          data: { email },
          errors: { _errors: ["Invalid Email or Password"] }
        });
      }
    } catch (e) {
      console.error("Login DB error:", e);
      return fail(500, {
        data: { email },
        errors: { _errors: ["An unexpected error occurred. Please try again later."] }
      });
    }
    const isValidPassword = await auth.compare(password.toString(), user.password);
    if (!isValidPassword) {
      return fail(401, {
        data: { email },
        errors: { _errors: ["Invalid Email or Password"] }
      });
    }
    const isAdmin = await auth.isAdmin(user);
    if (!isAdmin && !user.isVerified) {
      return fail(401, {
        data: { email },
        errors: { _errors: ["Account not verified. Please check your email for verification link."] }
      });
    }
    const sessionId = await auth.generateSessionId();
    await auth.saveSessionToken(user.id, sessionId);
    const token = auth.sign(user, sessionId);
    const refreshToken = await auth.generateRefreshToken(user);
    cookies.set("token", token, {
      httpOnly: true,
      secure,
      path: "/",
      maxAge
    });
    cookies.set("refreshToken", refreshToken, {
      httpOnly: true,
      secure,
      path: "/",
      maxAge: formData?.rememberMe ? refreshTokenMaxAge : void 0
    });
    throw redirect(303, isAdmin ? "/admin/product" : "/product");
  }
};
export {
  actions
};
